module.exports = __webpack_public_path__ + "media/images/slide3-c3609e862fc8c64191a327152ca96f1a425185ea945c533d4ab9f96e1ad85afb.jpg";